<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import UserState from "@/stores/UserState";
import "./utils/side-effect-imports";
import Settings from "./stores/Settings";
import { Logger } from "./logger";
import { useResponsiveController } from "@/composable/useResponsive";
import PWAToast from "./components/pwa/PWAPopup.vue";
import InstallAppBanner from "./components/pwa/InstallAppBanner.vue";
import LegendViewerModal from "./components/canvas/DrawerMenus/Settings/LegendViewerModal.vue";
import MemoryOverlay from "./components/debug/MemoryOverlay.vue";

const showMemDbg = new URLSearchParams(window.location.search).has("memdbg");

useResponsiveController();
const route = useRoute();

// Need to import Settings to get access to the routes
Settings.initialize();
// Init user before mounting the app in order to get access to the routes
UserState.initialize();
Logger.identify();
</script>

<template>
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
      <component :is="Component"></component>
    </template>
  </RouterView>

  <PWAToast v-if="route.name !== 'canvas'" />
  <InstallAppBanner v-if="route.name !== 'canvas'" />
  <LegendViewerModal />
  <MemoryOverlay v-if="showMemDbg" />
</template>

<style lang="scss"></style>
